var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-navbars-container"},[_c('BreadcrumbIndex'),(_vm.setShowTagsView)?_c('TagsView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }